import React from "react";
import {
  useSmartDownload,
  getDownloadLabel,
  DOWNLOAD_GRADIENT,
} from "../../hooks/useSmartDownload";
import DownloadOSIcon from "./DownloadOSIcon";

/**
 * Navbar variant of the OS-aware download button: the OS icon is shown plain in
 * white (no white circle behind it). Triggers the same smart download as the
 * home CTAs - Windows downloads the installer + shows the modal, Android opens
 * Play Store, Mac/iPhone open their App Store listing.
 *
 * `className` sizes the button and `iconClassName` sizes the icon.
 */
const NavDownloadButton = ({
  className = "",
  iconClassName = "",
  location = "navbar",
  showIcon = true,
  compact = false,
}) => {
  const smartDownload = useSmartDownload();
  // On tight layouts (mobile navbar) show just "Download" beside the OS icon,
  // instead of the full "Download for Android/Windows/…" label which overflows.
  const label = compact ? "Download" : getDownloadLabel();

  return (
    <button
      type="button"
      onClick={() => smartDownload(location)}
      style={{ background: DOWNLOAD_GRADIENT }}
      className={`hover:opacity-90 cursor-pointer transition-all duration-300 ease-in-out font-inter text-white font-semibold flex items-center justify-center gap-2 rounded-full ${className}`}
    >
      {showIcon && <DownloadOSIcon className={`text-white ${iconClassName}`} />}
      {label}
    </button>
  );
};

export default NavDownloadButton;
